import { TableField } from "../table-field";

export const fieldsOscip: TableField[] = [
  {
    key: "NrCnpj",
    label: "CNPJ",
    tdClass: "align-middle naoQuebrar",
    thClass: "text-center",
    sortable: false,
  },
  {
    key: "NmEntidade",
    label: "Nome da Entidade",
    tdClass: "align-middle quebrarPorPalavra",
    thClass: "text-center quebrarPorPalavraHard",
    sortable: false,
  },
  {
    key: "NmCidade",
    label: "Cidade",
    tdClass: "align-middle quebrarPorPalavra",
    thClass: "text-center naoQuebrar",
    sortable: false,
  },
  {
    key: "NmCep",
    label: "CEP",
    tdClass: "align-middle naoQuebrar",
    thClass: "text-center naoQuebrar",
    sortable: false,
  },
  {
    key: "DtPublicacaoDou",
    label: "Data Publicação DOU",
    tdClass: "align-middle naoQuebrar",
    thClass: "text-center quebrarPorPalavra",
    sortable: false,
    formatter: (dt: Date): string => (dt ? dt.toLocaleDateString() : ""),
  },
  {
    key: "FlAtivo",
    label: "Situação",
    tdClass: "align-middle quebrarPorPalavra",
    thClass: "text-center naoQuebrar",
    sortable: false,
    formatter: (sit: boolean): string => (sit ? "Ativo" : "Inativo"),
  },
  {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: "text-center",
    sortable: false,
  },
];
